<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="3">
                <app-form-select-input
                    v-model="filters.serviceSpotTypeId"
                    placeholder="Tipo"
                    :options="serviceSpotTypes"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="3">
                <app-form-select-input
                    v-model="filters.venueId"
                    placeholder="Sede"
                    :options="venues"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="3">
                <b-btn variant="primary" @click="filter"><i class="fa fa-filter"></i></b-btn>
                <b-btn variant="secondary" @click="clear"><i class="fa fa-times"></i></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>

export default {
    props: {
        theClient: {
            type: Object,
            required: true
        },
        venues: {
            type: Array,
            default: () => []
        },
        serviceSpotTypes: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        filters: {
            serviceSpotTypeId: '',
            venueId: ''
        },
    }),
    methods: {
        filter() {
            this.$emit('filter', this.filters);
        },
        clear() {
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('clear', null);
        }
    },
}
</script>